import type { ResidentApplicationData } from '@/types/application'
import type { EmploymentImportMode } from '../types/utils'

/** Offer employment import when current_job empty and oldapplication has data (Angular importOldata). */
export function shouldOfferEmploymentImport(
  applicationData: ResidentApplicationData | null | undefined,
  isReadOnly: boolean,
): boolean {
  if (isReadOnly || !applicationData) return false

  const currentJob = applicationData.current_job
  if (!Array.isArray(currentJob)) return false
  if (currentJob.length > 0) return false

  if (applicationData.job_gap_description) return false

  const oldApp = applicationData.oldapplication
  return (
    !!oldApp?.user_data &&
    ((oldApp.current_employment?.length ?? 0) > 0 ||
      (oldApp.previous_employment?.length ?? 0) > 0)
  )
}

/** Patch application data after employment import (Angular setOldApplicationData). */
export function buildEmploymentImportUpdate(
  applicationData: ResidentApplicationData,
  mode: EmploymentImportMode,
): ResidentApplicationData | null {
  const oldApp = applicationData.oldapplication
  if (!oldApp?.user_data) return null

  const oldCurrent = oldApp.current_employment ?? []
  const oldPrevious = oldApp.previous_employment ?? []

  if (mode === 'current') {
    return {
      ...applicationData,
      employment_status: '1',
      current_employment: oldCurrent,
      current_job: oldCurrent as ResidentApplicationData['current_job'],
      ...(oldPrevious.length > 0
        ? {
            previous_employer: '1',
            previous_employment: oldPrevious,
            previous_job: oldPrevious as ResidentApplicationData['previous_job'],
          }
        : {}),
    }
  }

  const mergedPrevious = [...oldCurrent, ...oldPrevious]
  return {
    ...applicationData,
    previous_employer: '1',
    previous_employment: mergedPrevious,
    previous_job: mergedPrevious as ResidentApplicationData['previous_job'],
  }
}
